// import axios from "axios";
// import Swal from "sweetalert2";

// axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// // Request interceptor → Attach token
// axios.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response interceptor → Catch Unauthorized
// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401) {

//       // Show SweetAlert before redirect
//       await Swal.fire({
//         title: "Session Timeout",
//         text: "Your session has expired. Please login again.",
//         icon: "warning",
//         confirmButtonText: "OK",
//       });

//       // Clear token + redirect to login
//       localStorage.removeItem("jwtToken");
//       window.location.href = "/Login";
//     }

//     return Promise.reject(error);
//   }
// );

// export default axios;
import axios from "axios";
import Swal from "sweetalert2";

// Base API URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Global request timeout (important)
axios.defaults.timeout = 30000; // 30 seconds

/* ================================
   Request Interceptor
================================ */
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // ✅ consistent key

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================================
   Response Interceptor
================================ */
axios.interceptors.response.use(
  (response) => response,
  async (error) => {

    // 🚨 Case 1: Server did NOT respond (timeout / crash / network hang)
    if (!error.response) {
      await Swal.fire({
        title: "Server Not Responding",
        text: "The server is taking too long to respond. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });

      return Promise.reject(error);
    }

    // 🚨 Case 2: Unauthorized / Session expired
    if (error.response.status === 401) {
      await Swal.fire({
        title: "Session Timeout",
        text: "Your session has expired. Please login again.",
        icon: "warning",
        confirmButtonText: "OK",
      });

      // ✅ Clear correct token
      localStorage.removeItem("token");

      // Redirect to login
      window.location.href = "/Login";
    }

    // 🚨 Case 3: Other server errors (optional but recommended)
    if (error.response.status >= 500) {
      Swal.fire({
        title: "Server Error",
        text: "Something went wrong on the server. Please try again later.",
        icon: "error",
      });
    }

    return Promise.reject(error);
  }
);

export default axios;
